"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCountryFlagImg = exports.getCountries = exports.DEFAULT_COUNTRY_CODE = void 0;
const max_1 = require("libphonenumber-js/max");
const i18n_iso_countries_1 = require("i18n-iso-countries");
const AppConfig_1 = __importDefault(require("../AppConfig"));
exports.DEFAULT_COUNTRY_CODE = 'RU';
function getCountries() {
  let lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : exports.DEFAULT_COUNTRY_CODE;
  const countryByCode = (0, i18n_iso_countries_1.getNames)(lang);
  const countries = [];
  Object.keys(countryByCode).forEach(countryCode => {
    const countryName = countryByCode[countryCode];
    try {
      countries.push({
        code: countryCode,
        name: Array.isArray(countryName) ? countryName[0] : countryName,
        phoneCode: (0, max_1.getCountryCallingCode)(countryCode)
      });
    } catch (e) {}
  });
  return countries;
}
exports.getCountries = getCountries;
function getCountryFlagImg(countryCode) {
  return `${AppConfig_1.default.routerBasePath}/img/country-flags/${countryCode.toLowerCase()}.png`;
}
exports.getCountryFlagImg = getCountryFlagImg;